import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

const initSliderStoriesCards = () => {
  const sliderStoriesCards = $Q('.stories-cards__swiper.swiper');

  if( !sliderStoriesCards ) return;

  new Swiper(sliderStoriesCards, {
    modules: [Pagination, Navigation],
    slidesPerView: 4,
    breakpoints: {
      280: {
        slidesPerView: "auto"
      },
      640: {
        slidesPerView: 3
      },
      980: {
        slidesPerView: 4
      }
    },
    spaceBetween: 15,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: false
  });
};

initSliderStoriesCards();
